import {IonAvatar, IonBadge, IonButton, IonButtons, IonCol, IonContent, IonGrid, IonHeader, IonImg, IonInfiniteScroll, IonInfiniteScrollContent, IonItem, IonLabel, IonList, IonMenuButton, IonNote, IonPage, IonRefresher, IonRefresherContent, IonRouterLink, IonRow, IonSelect, IonSelectOption, IonText, IonTitle, IonToolbar, RefresherEventDetail, useIonRouter} from '@ionic/react';
import {capitalize, productInfo} from '../utils';
import {useStoreState} from 'pullstate';

import styles from "./Categories.module.scss";
import {fetch_pg_0_3, Pg_0_1_Store, Pg_0_3_Store, push_pg_0_3} from "../store/Pg_0_Store";
import {getPageData, getQuotes} from "../store/Selectors";
import {useCallback, useContext, useEffect, useRef, useState} from "react";
import {QuoteItem} from "../components/QuoteItem";
import {ContractItem} from "../components/ContractItem";
//import {fetch_pg_0_1} from "../store/Pg_1_Store";
import {useSideMenuOptions, useSideMenuUpdate} from "../components/sideMenu/SideMenuProvider";
import CustomPage from "./CustomPage";
import {PageHeader} from "./PageHeader";
import {Modal} from "./Modal";
import {tab1SideMenu} from "../components/sideMenu/PageSideMenus";
import Ln_AvaterPictureSetCoverImg from "./Ln_AvaterPictureSetCoverImg";
import Ln_ContractPictureSetCoverImg from "./Ln_ContractPictureSetCoverImg";
import {fetch_pg_2_1, Pg_2_1_Store} from "../store/Pg_2_Store";
import {chevronDownCircleOutline} from "ionicons/icons";
import styles_Pg_0_2 from "./Pg_0_2.module.scss";
import styles_Pg_0_3 from "./Pg_0_3.module.scss";
import Ln_TokenPictureSetCoverImg from "./Ln_TokenPictureSetCoverImg";
import QRCode from "react-qr-code";
import {useFormInput, validateForm} from "../_/useForms";
import CustomField from "../components/CustomField";
import styles_Pg_C_1 from "./Pg_C_1.module.scss";
import {Pg_B_1_Store, push_pg_B_1_emailverify, push_pg_B_1_sendemailverify} from "../store/Pg_B_Store";
import {Pg_C_4_Store, push_pg_C_1, push_pg_C_4_phoneverify, push_pg_C_4_sendphoneverify} from "../store/Pg_C_Store";
import {useParams} from "react-router";
import indexBy from "underscore/modules/indexBy";
import {handleFetchCommonErrors} from "./Utils";
import Uploady, {useBatchAddListener, useItemProgressListener, useRequestPreSend} from "@rpldy/uploady";
import ChunkedUploady, {UploadyContext, useBatchFinishListener, useChunkStartListener} from "@rpldy/chunked-uploady";
import UploadButton from "@rpldy/upload-button";
import AddCircleOutlineSharp from "@mui/icons-material/AddCircleOutlineSharp";
import Button from '@mui/material/Button';
import {v4 as uuidv4} from "uuid";
import MyUploadProgress from "./MyUploadProgress";
import MyUploadFail from "./MyUploadFail";
import styles_Common from "./Common.module.scss";

const MAX_FILE_SIZE = 99000000;
const MyUploadButton = ({setUploadedFile}) => {
    const uploady = useContext(UploadyContext);
    const [fileId, set_fileId] = useState("");
    useRequestPreSend(({items}) => {
        const _fileID = uuidv4() + "." + items[0].file.name.split(".").pop();
        set_fileId(_fileID);
        return {
            options: {
                destination: {
                    params: {
                        fileId: fileId
                    }
                }
            }
        };
    });
    useChunkStartListener(({chunk, chunkItem}) => {
        return {
            sendOptions: {
                method: "POST",
                paramName: "data",
                params: {
                    // chunkId: chunk?.index,
                    fileSize: chunkItem?.file?.size
                }
            }
        };
    });
    useBatchAddListener((batch) => {
        let result;
        if (batch?.items[0]?.file?.size > MAX_FILE_SIZE) {
            result = false; //false will cancel.
        }
        return result;
    });
    useBatchFinishListener((batch) => {
        if (batch?.items[0]?.state === "finished") {
            // saveUploadedDocumentToProject({fileName: batch?.items[0]?.file.name,fileId: fileID,});

            let fileId_2 = JSON.parse(batch.items[0].uploadResponse.results[0].data).files[0].id;
            //console.log(fileId);

            setUploadedFile(fileId_2);
        }
    });
    const handleUpload = useCallback(() => {
        uploady.showFileUpload();
    }, [uploady]);
    return (
        <Button onClick={handleUpload}>
            <AddCircleOutlineSharp/>
            <span>&nbsp;&nbsp;更換圖片</span>
        </Button>
    );
};


const customSelectContainerOptions = {
    header: '手機國際碼',
    subHeader: '',
    message: '請選擇一項',
    translucent: false,
};

let areaCodeList: any = [
    {
        "countryCode": "TW",
        "countryName": "台灣",
        "phoneCode": "+886"
    },
    {
        "countryCode": "CN",
        "countryName": "中國",
        "phoneCode": "+86"
    },
    {
        "countryCode": "HK",
        "countryName": "香港",
        "phoneCode": "+852"
    },
    {
        "countryCode": "MO",
        "countryName": "澳門",
        "phoneCode": "+853"
    },
    {
        "countryCode": "US",
        "countryName": "美國",
        "phoneCode": "+1"
    },
    {
        "countryCode": "CA",
        "countryName": "加拿大",
        "phoneCode": "+1"
    },
    {
        "countryCode": "UK",
        "countryName": "英國",
        "phoneCode": "+44"
    },
    {
        "countryCode": "SG",
        "countryName": "新加坡",
        "phoneCode": "+65"
    },
    {
        "countryCode": "NZ",
        "countryName": "紐西蘭",
        "phoneCode": "+64"
    },
    {
        "countryCode": "JP",
        "countryName": "日本",
        "phoneCode": "+81"
    },
    {
        "countryCode": "KP",
        "countryName": "韓國",
        "phoneCode": "+82"
    },
    {
        "countryCode": "AU",
        "countryName": "澳大利亞",
        "phoneCode": "+61"
    },
    {
        "countryCode": "FR",
        "countryName": "法國",
        "phoneCode": "+33"
    },
    {
        "countryCode": "DE",
        "countryName": "德國",
        "phoneCode": "+49"
    },



    // {
    //     "countryCode": "AF",
    //     "countryName": "阿富汗",
    //     "phoneCode": "+93"
    // },
    // {
    //     "countryCode": "AR",
    //     "countryName": "阿根廷",
    //     "phoneCode": "+54"
    // },
    // {
    //     "countryCode": "AT",
    //     "countryName": "奧地利",
    //     "phoneCode": "+43"
    // },
    //
    // {
    //     "countryCode": "BH",
    //     "countryName": "巴林",
    //     "phoneCode": "+973"
    // },
    // {
    //     "countryCode": "BD",
    //     "countryName": "孟加拉",
    //     "phoneCode": "+880"
    // },
    // {
    //     "countryCode": "BE",
    //     "countryName": "比利時",
    //     "phoneCode": "+32"
    // },
    // {
    //     "countryCode": "BT",
    //     "countryName": "不丹",
    //     "phoneCode": "+975"
    // },
    // {
    //     "countryCode": "BO",
    //     "countryName": "玻利維亞",
    //     "phoneCode": "+591"
    // },
    // {
    //     "countryCode": "BR",
    //     "countryName": "巴西",
    //     "phoneCode": "+55"
    // },
    // {
    //     "countryCode": "KH",
    //     "countryName": "柬埔寨",
    //     "phoneCode": "+855"
    // },
    // {
    //     "countryCode": "CM",
    //     "countryName": "喀麥隆",
    //     "phoneCode": "+237"
    // },
    // {
    //     "countryCode": "AI",
    //     "countryName": "安圭拉",
    //     "phoneCode": "+1264"
    // },
    // {
    //     "countryCode": "AG",
    //     "countryName": "安地瓜",
    //     "phoneCode": "+1268"
    // },
    // {
    //     "countryCode": "AW",
    //     "countryName": "阿魯巴",
    //     "phoneCode": "+297"
    // },
    // {
    //     "countryCode": "BM",
    //     "countryName": "百慕達",
    //     "phoneCode": "+1441"
    // },
    // {
    //     "countryCode": "DO",
    //     "countryName": "多明尼加",
    //     "phoneCode": "+1767"
    // },
    // {
    //     "countryCode": "GD",
    //     "countryName": "格瑞那達",
    //     "phoneCode": "+1473"
    // },
    // {
    //     "countryCode": "LC",
    //     "countryName": "聖盧西亞",
    //     "phoneCode": "+1758"
    // },
    // {
    //     "countryCode": "CO",
    //     "countryName": "哥倫比亞",
    //     "phoneCode": "+57"
    // },
    // {
    //     "countryCode": "CG",
    //     "countryName": "剛果共和國",
    //     "phoneCode": "+243"
    // },
    // {
    //     "countryCode": "CH",
    //     "countryName": "瑞士",
    //     "phoneCode": "+41"
    // },
    //
    // {
    //     "countryCode": "DK",
    //     "countryName": "丹麥",
    //     "phoneCode": "+45"
    // },
    // {
    //     "countryCode": "EG",
    //     "countryName": "埃及",
    //     "phoneCode": "+20"
    // },
    // {
    //     "countryCode": "ES",
    //     "countryName": "西班牙",
    //     "phoneCode": "+34"
    // },
    // {
    //     "countryCode": "SV",
    //     "countryName": "薩爾瓦多",
    //     "phoneCode": "+503"
    // },
    // {
    //     "countryCode": "FI",
    //     "countryName": "芬蘭",
    //     "phoneCode": "+358"
    // },
    // {
    //     "countryCode": "FJ",
    //     "countryName": "斐濟",
    //     "phoneCode": "+679"
    // },
    //
    // {
    //     "countryCode": "GE",
    //     "countryName": "喬治亞",
    //     "phoneCode": "+995"
    // },
    // {
    //     "countryCode": "GH",
    //     "countryName": "迦納",
    //     "phoneCode": "+233"
    // },
    // {
    //     "countryCode": "GR",
    //     "countryName": "希臘",
    //     "phoneCode": "+30"
    // },
    // {
    //     "countryCode": "GT",
    //     "countryName": "瓜地馬拉",
    //     "phoneCode": "+502"
    // },
    // {
    //     "countryCode": "GY",
    //     "countryName": "蓋亞那",
    //     "phoneCode": "+967"
    // },
    // {
    //     "countryCode": "HT",
    //     "countryName": "海地",
    //     "phoneCode": "+509"
    // },
    // {
    //     "countryCode": "HN",
    //     "countryName": "宏都拉斯",
    //     "phoneCode": "+504"
    // },
    //
    // {
    //     "countryCode": "IN",
    //     "countryName": "印度",
    //     "phoneCode": "+91"
    // },
    // {
    //     "countryCode": "IS",
    //     "countryName": "冰島",
    //     "phoneCode": "+354"
    // },
    // {
    //     "countryCode": "ID",
    //     "countryName": "印尼",
    //     "phoneCode": "+62"
    // },
    // {
    //     "countryCode": "IQ",
    //     "countryName": "伊拉克",
    //     "phoneCode": "+964"
    // },
    // {
    //     "countryCode": "IE",
    //     "countryName": "愛爾蘭",
    //     "phoneCode": "+353"
    // },
    // {
    //     "countryCode": "IT",
    //     "countryName": "義大利",
    //     "phoneCode": "+39"
    // },
    // {
    //     "countryCode": "JM",
    //     "countryName": "牙買加",
    //     "phoneCode": "+1876"
    // },
    // {
    //     "countryCode": "JO",
    //     "countryName": "約旦",
    //     "phoneCode": "+962"
    // },
    // {
    //     "countryCode": "KZ",
    //     "countryName": "哈薩克",
    //     "phoneCode": "+7"
    // },
    // {
    //     "countryCode": "KE",
    //     "countryName": "肯亞",
    //     "phoneCode": "+254"
    // },
    //
    // {
    //     "countryCode": "KW",
    //     "countryName": "科威特",
    //     "phoneCode": "+965"
    // },
    // {
    //     "countryCode": "LU",
    //     "countryName": "盧森堡",
    //     "phoneCode": "+352"
    // },
    //
    // {
    //     "countryCode": "MK",
    //     "countryName": "馬其頓",
    //     "phoneCode": "+389"
    // },
    // {
    //     "countryCode": "MG",
    //     "countryName": "馬達加斯加",
    //     "phoneCode": "+261"
    // },
    // {
    //     "countryCode": "ML",
    //     "countryName": "馬來西亞",
    //     "phoneCode": "+60"
    // },
    // {
    //     "countryCode": "MV",
    //     "countryName": "馬爾地夫",
    //     "phoneCode": "+960"
    // },
    // {
    //     "countryCode": "MX",
    //     "countryName": "墨西哥",
    //     "phoneCode": "+52"
    // },
    // {
    //     "countryCode": "MA",
    //     "countryName": "摩洛哥",
    //     "phoneCode": "+212"
    // },
    // {
    //     "countryCode": "NO",
    //     "countryName": "挪威",
    //     "phoneCode": "+47"
    // },
    // {
    //     "countryCode": "NR",
    //     "countryName": "諾魯",
    //     "phoneCode": "+674"
    // },
    //
    // {
    //     "countryCode": "NI",
    //     "countryName": "尼加拉瓜",
    //     "phoneCode": "+505"
    // },
    // {
    //     "countryCode": "NG",
    //     "countryName": "奈及利亞",
    //     "phoneCode": "+234"
    // },
    // {
    //     "countryCode": "PK",
    //     "countryName": "巴基斯坦",
    //     "phoneCode": "+92"
    // },
    // {
    //     "countryCode": "PA",
    //     "countryName": "巴拿馬",
    //     "phoneCode": "+507"
    // },
    // {
    //     "countryCode": "PG",
    //     "countryName": "巴布亞紐幾內亞",
    //     "phoneCode": "+675"
    // },
    // {
    //     "countryCode": "PT",
    //     "countryName": "葡萄牙",
    //     "phoneCode": "+351"
    // },
    // {
    //     "countryCode": "PY",
    //     "countryName": "巴拉圭",
    //     "phoneCode": "+595"
    // },
    // {
    //     "countryCode": "RO",
    //     "countryName": "羅馬尼亞",
    //     "phoneCode": "+40"
    // },
    // {
    //     "countryCode": "RU",
    //     "countryName": "俄羅斯",
    //     "phoneCode": "+7"
    // },
    // {
    //     "countryCode": "RW",
    //     "countryName": "盧旺達",
    //     "phoneCode": "+250"
    // },
    // {
    //     "countryCode": "SA",
    //     "countryName": "沙烏地阿拉伯",
    //     "phoneCode": "+966"
    // },
    // {
    //     "countryCode": "SY",
    //     "countryName": "敘利亞",
    //     "phoneCode": "+381"
    // },
    // {
    //     "countryCode": "SC",
    //     "countryName": "塞席爾",
    //     "phoneCode": "+248"
    // },
    // {
    //     "countryCode": "LK",
    //     "countryName": "斯里蘭卡",
    //     "phoneCode": "+94"
    // },
    //
    // {
    //     "countryCode": "SD",
    //     "countryName": "蘇丹",
    //     "phoneCode": "+249"
    // },
    // {
    //     "countryCode": "SE",
    //     "countryName": "瑞典",
    //     "phoneCode": "+46"
    // },
    // {
    //     "countryCode": "TL",
    //     "countryName": "泰國",
    //     "phoneCode": "+66"
    // },
    // {
    //     "countryCode": "TO",
    //     "countryName": "湯加群島",
    //     "phoneCode": "+676"
    // },
    // {
    //     "countryCode": "TR",
    //     "countryName": "土耳其",
    //     "phoneCode": "+90"
    // },
    // {
    //     "countryCode": "UG",
    //     "countryName": "烏干達",
    //     "phoneCode": "+256"
    // },
    // {
    //     "countryCode": "UA",
    //     "countryName": "烏克蘭",
    //     "phoneCode": "+380"
    // },
    // {
    //     "countryCode": "AE",
    //     "countryName": "阿拉伯聯合大公國",
    //     "phoneCode": "+971"
    // },
    // {
    //     "countryCode": "UY",
    //     "countryName": "烏拉圭",
    //     "phoneCode": "+598"
    // },
    // {
    //     "countryCode": "UZ",
    //     "countryName": "烏茲別克",
    //     "phoneCode": "+998"
    // },
    // {
    //     "countryCode": "VE",
    //     "countryName": "委內瑞拉",
    //     "phoneCode": "+58"
    // },
    // {
    //     "countryCode": "YE",
    //     "countryName": "葉門",
    //     "phoneCode": "+967"
    // }
];
// export const useRegisterFields = () => {
//     return [
//         {
//             id: "scodeEmail",
//             nodisplay: true,
//             label: "scodeEmail",
//             required: false,
//             value: null,
//         },
//         {
//             id: "vcodeEmail",
//             nodisplay: false,
//             label: "vcodeEmail",
//             required: false,
//             input: {
//                 props: {
//                     type: "email",
//                     placeholder: "",
//                 },
//                 state: useFormInput("")
//             }
//         },
//         {
//             id: "scodePhone",
//             nodisplay: true,
//             label: "scodePhone",
//             required: false,
//             value: null,
//         },
//         {
//             id: "vcodePhone",
//             nodisplay: false,
//             label: "vcodePhone",
//             required: false,
//             input: {
//                 props: {
//                     type: "email",
//                     placeholder: "",
//                 },
//                 state: useFormInput("")
//             }
//         },
//
//         {
//             id: "電子郵件",
//             label: "電子郵件",
//             required: true,
//             input: {
//                 props: {
//                     type: "email",
//                     placeholder: "",
//                     autocomplete: "username",
//                 },
//                 state: useFormInput("raymond0321@gmail.com")
//             }
//         },
//         {
//             id: "手機國碼",
//             label: "手機國碼",
//             required: true,
//             input: {
//                 props: {
//                     type: "text",
//                     placeholder: "",
//
//                 },
//                 state: useFormInput("121212")
//             }
//         },
//         {
//             id: "手機號碼",
//             label: "手機號碼",
//             required: true,
//             input: {
//                 props: {
//                     type: "text",
//                     placeholder: "",
//                     autocomplete: "tel-local"
//                 },
//                 state: useFormInput("121212")
//             }
//         },
//         {
//             id: "登入密碼",
//             label: "密碼",
//             required: true,
//             input: {
//                 props: {
//                     type: "password",
//                     placeholder: "",
//                     autocomplete: "new-password"
//                 },
//                 state: useFormInput("121212")
//             }
//         },
//         {
//             id: "個人介紹",
//             label: "個人介紹",
//             required: true,
//             input: {
//                 props: {
//                     type: "text",
//                     placeholder: "",
//                     rows: 3,
//                     autoGrow: true,
//                 },
//                 state: useFormInput("121212")
//             }
//         },
//         {
//             id: "寄送地址",
//             label: "寄送地址",
//             required: true,
//             input: {
//                 props: {
//                     type: "text",
//                     placeholder: "",
//                     rows: 3,
//                     autoGrow: true,
//                 },
//                 state: useFormInput("121212")
//             }
//         },
//     ];
// }

const RenderForm = ({router, Item_會員, reload}) => {
    const [errors, setErrors] = useState(false);
    const [emailVerifyStage, setEmailVerifyStage] = useState<number>(0);
    const [phoneVerifyStage, setPhoneVerifyStage] = useState<number>(0);


    const [uploadedFile, setUploadedFile] = useState(Item_會員.個人照片);


    //#region +Event
    const fields = [
        {
            id: "scodeEmail",
            nodisplay: true,
            label: "scodeEmail",
            required: false,
            value: null,
        },
        {
            id: "vcodeEmail",
            nodisplay: false,
            label: "vcodeEmail",
            required: false,
            input: {
                props: {
                    type: "email",
                    placeholder: "",
                },
                state: useFormInput("")
            }
        },
        {
            id: "scodePhone",
            nodisplay: true,
            label: "scodePhone",
            required: false,
            value: null,
        },
        {
            id: "vcodePhone",
            nodisplay: false,
            label: "vcodePhone",
            required: false,
            input: {
                props: {
                    type: "email",
                    placeholder: "",
                },
                state: useFormInput("")
            }
        },

        {
            id: "電子郵件",
            label: "電子郵件",
            required: true,
            input: {
                props: {
                    type: "email",
                    placeholder: "電子郵件",
                    autocomplete: "username",
                },
                state: useFormInput(Item_會員.Email, (val, oldVal) => {
                    if (val === oldVal) {
                        setEmailVerifyStage(0);
                    } else {
                        setEmailVerifyStage(1);
                    }
                })
            }
        },
        {
            id: "手機國碼",
            label: "手機國際碼",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "手機國際碼",
                },
                state: useFormInput(Item_會員.手機國碼, (val, oldVal) => {

                })
            }
        },
        {
            id: "手機號碼",
            label: "手機號碼",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "手機號碼",
                    autocomplete: "tel-local"
                },
                state: useFormInput(Item_會員.手機, (val, oldVal) => {

                })
            }
        },
        {
            id: "登入密碼",
            label: "密碼",
            required: true,
            input: {
                props: {
                    type: "password",
                    placeholder: "密碼",
                    autocomplete: "new-password"
                },
                state: useFormInput(Item_會員.登入密碼)
            }
        },
        {
            id: "個人介紹",
            label: "個人介紹",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "個人介紹",
                    rows: 3,
                    autoGrow: true,
                },
                state: useFormInput(Item_會員.個人介紹)
            }
        },
        {
            id: "寄送地址_收件人",
            label: "收件人",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "收件人",
                    rows: 3,
                    autoGrow: true,
                },
                state: useFormInput(Item_會員.CardSendReceiver)
            }
        },
        {
            id: "寄送地址_連絡電話",
            label: "連絡電話",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "連絡電話",
                    rows: 3,
                    autoGrow: true,
                },
                state: useFormInput(Item_會員.CardSendContactPhone)
            }
        },
        {
            id: "寄送地址_收件地址",
            label: "收件地址",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "收件地址",
                    rows: 3,
                    autoGrow: true,
                },
                state: useFormInput(Item_會員.CardSendAddress)
            }
        },
        {
            id: "暱稱",
            label: "顯示名稱",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "顯示名稱",
                    rows: 3,
                    autoGrow: true,
                },
                state: useFormInput(Item_會員.暱稱)
            }
        },
    ];

    let keyedFields = indexBy(fields, 'id');

    useEffect(() => {
        if (`${keyedFields.手機號碼.input.state.initialValue}${keyedFields.手機國碼.input.state.initialValue}` ===
            `${keyedFields.手機號碼.input.state.value}${keyedFields.手機國碼.input.state.value}`) {
            setPhoneVerifyStage(0);
        } else {
            setPhoneVerifyStage(1);
        }
    }, [keyedFields.手機號碼.input.state.value, keyedFields.手機國碼.input.state.value]);

    //#region push register
    const _push_pg_0_3 = async () => {
        const errors = validateForm(fields);
        setErrors(errors);

        if (!errors.length) {
            //  Submit your form here
            let keyedFields = indexBy(fields, 'id');
            //const username = fields && (fields.filter(e => e.id === 'email')[0] as any).input.state.value;
            //const password = fields && (fields.filter(e => e.id === 'password')[0] as any).input.state.value;

            //const scodeEmail = fields && (keyedFields.scodeEmail as any).value;
            //const vcodeEmail = fields && (keyedFields.vcodeEmail as any).value;
            //const scodePhone = fields && (keyedFields.scodePhone as any).value;
            //const vcodePhone = fields && (keyedFields.vcodePhone as any).value;

            let {email, scodeEmail, vcodeEmail} = Pg_B_1_Store.getRawState() as any;
            let {phone, scodePhone, vcodePhone} = Pg_C_4_Store.getRawState() as any;

            if (emailVerifyStage !== 4 && emailVerifyStage !== 0) {
                alert("因為電子信箱改變過，請再次先完成Email驗證流程");
                return;
            }
            if (phoneVerifyStage !== 4 && phoneVerifyStage !== 0) {
                alert("因為手機號改變過，請再次先完成手機驗證流程");
                return;
            }

            const 電子郵件 = fields && (keyedFields.電子郵件 as any).input.state.value;

            const 登入密碼 = fields && (keyedFields.登入密碼 as any).input.state.value;
            const 手機國碼 = fields && (keyedFields.手機國碼 as any).input.state.value;
            const 手機號碼 = fields && (keyedFields.手機號碼 as any).input.state.value;

            const 個人介紹 = fields && (keyedFields.個人介紹 as any).input.state.value;
            const 個人照片 = uploadedFile;

            const 寄送地址_收件人 = fields && (keyedFields.寄送地址_收件人 as any).input.state.value;
            const 寄送地址_連絡電話 = fields && (keyedFields.寄送地址_連絡電話 as any).input.state.value;
            const 寄送地址_收件地址 = fields && (keyedFields.寄送地址_收件地址 as any).input.state.value;

            const 暱稱 = fields && (keyedFields.暱稱 as any).input.state.value;

            //const password = fields && (fields.filter(e => e.id === 'password')[0] as any).input.state.value;
            //const password = fields && (fields.filter(e => e.id === 'password')[0] as any).input.state.value;

            try {
                if (await push_pg_0_3({
                    scodeEmail,
                    vcodeEmail,
                    scodePhone,
                    vcodePhone,
                    電子郵件,
                    手機號碼,
                    手機國碼,
                    登入密碼,
                    個人介紹,
                    個人照片,
                    寄送地址_收件人,
                    寄送地址_連絡電話,
                    寄送地址_收件地址,
                    暱稱,
                })) {
                    alert('更新成功')
                    reload();
                }
            } catch (err) {
            }
        }
    }

    const _push_Pg_C_4__SendPhoneVerify = async () => {
        const 手機國碼 = fields && (keyedFields.手機國碼 as any).input.state.value;
        const 手機號碼 = fields && (keyedFields.手機號碼 as any).input.state.value;
        setPhoneVerifyStage(2);
        try {
            if (await push_pg_C_4_sendphoneverify({
                p1: `${手機國碼}${手機號碼}`,
            })) {
                let {phone, scodePhone} = Pg_C_4_Store.getRawState() as any;
                setPhoneVerifyStage(3);
                //navToPg_1_1();
            }
        } catch (err) {
            setPhoneVerifyStage(1);
        }
    }

    const _push_Pg_C_4__PhoneVerify = async () => {
        const 手機國碼 = fields && (keyedFields.手機國碼 as any).input.state.value;
        const 手機號碼 = fields && (keyedFields.手機號碼 as any).input.state.value;
        let {phone, scodePhone} = Pg_C_4_Store.getRawState() as any;
        const vcodePhone = fields && (keyedFields.vcodePhone as any).input.state.value;

        if (!vcodePhone) {
            alert('請填入驗證碼');
            return;
        }
        if (phone !== `${手機國碼}${手機號碼}`) {
            alert('手機號碼已被修改，請重新驗證');
            setPhoneVerifyStage(1);
            return;
        }
        //setPhoneVerifyStage(3);
        // setPhoneVerifyStage(2);
        if (await push_pg_C_4_phoneverify({
            p1: phone,
            scodePhone: scodePhone,
            vcodePhone: vcodePhone,
        })) {
            setPhoneVerifyStage(4);
            //navToPg_1_1();
        }
    }

    const _push_Pg_B_1__SendEmailVerify = async () => {
        const 電子郵件 = fields && (keyedFields.電子郵件 as any).input.state.value;
        setEmailVerifyStage(2);
        try {
            if (await push_pg_B_1_sendemailverify({
                p1: `${電子郵件}`,
            })) {
                let {email, scodeEmail} = Pg_B_1_Store.getRawState() as any;
                setEmailVerifyStage(3);
                //navToPg_1_1();
            }
        } catch (err) {
            setEmailVerifyStage(1);
        }
    }

    const _push_Pg_B_1__EmailVerify = async () => {
        const 電子郵件 = fields && (keyedFields.電子郵件 as any).input.state.value;
        let {email, scodeEmail} = Pg_B_1_Store.getRawState() as any;
        const vcodeEmail = fields && (keyedFields.vcodeEmail as any).input.state.value;

        if (!vcodeEmail) {
            alert('請填入驗證碼');
            return;
        }
        if (email !== 電子郵件) {
            alert('信箱已被修改，請重新驗證');
            setEmailVerifyStage(1);
            return;
        }
        //setPhoneVerifyStage(3);
        // setPhoneVerifyStage(2);
        if (await push_pg_B_1_emailverify({
            p1: email,
            scodeEmail: scodeEmail,
            vcodeEmail: vcodeEmail,
        })) {
            setEmailVerifyStage(4);
            //navToPg_1_1();
        }
    }
    //#endregion

    //#endregion

    return <>
        <div className={`${styles_Pg_0_2.avatarContainer}`}>
            <div>
                <ChunkedUploady
                    destination={{url: "/MemberUploadHandler.ashx"}}
                    chunkSize={5242880}
                    multiple={false}
                >
                    <IonAvatar className="avatar">
                        {Ln_TokenPictureSetCoverImg({
                            圖片組: uploadedFile,
                            名稱: 'cover',
                        })}
                    </IonAvatar>
                    <div>
                        <MyUploadButton setUploadedFile={setUploadedFile}/>
                        <MyUploadProgress/>
                        <MyUploadFail/>
                    </div>
                </ChunkedUploady>


            </div>
            <div>
                <h6>{Item_會員.暱稱}</h6>
            </div>
        </div>

        <IonGrid className="ion-padding ion-margin-top ion-padding-top">
            <IonRow>
                <IonCol>
                    <CustomField field={keyedFields.暱稱} errors={errors}/>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol>
                    <CustomField field={keyedFields.電子郵件} errors={errors} disabled={emailVerifyStage === 4}/>
                </IonCol>
            </IonRow>
            {emailVerifyStage >= 1 &&
                <IonRow className="ion-justify-content-center ion-text-center ion-margin-top ">
                    <IonCol>
                        {emailVerifyStage === 1 &&
                            <>
                                <IonButton fill={"solid"} onClick={() => _push_Pg_B_1__SendEmailVerify()} disabled={emailVerifyStage !== 1 ? true : false}>
                                    再次驗證電子郵件
                                </IonButton>
                            </>
                        }
                        {emailVerifyStage === 2 &&
                            <>
                                寄件中，請稍後...
                            </>
                        }
                        {emailVerifyStage === 3 &&
                            <>
                                <CustomField alternateLabel={<>
                                    <IonLabel>
                                        請檢查郵件，並填入已寄送的代碼
                                    </IonLabel>
                                </>} alternateRightZone={<>
                                    <IonButton fill={"solid"} onClick={() => _push_Pg_B_1__EmailVerify()} className={styles_Common.sideRight}>
                                        驗證
                                    </IonButton>
                                </>
                                } field={keyedFields.vcodeEmail} errors={errors} className={styles_Pg_C_1.highlight} inputClassName={styles_Pg_C_1.hightlightColor}/>
                            </>
                        }
                        {emailVerifyStage === 4 &&
                            <>
                                驗證完成
                            </>
                        }
                    </IonCol>
                </IonRow>
            }
            <IonRow>
                <IonCol>
                    <CustomField alternateLeftZone={<>
                        <IonSelect value={keyedFields.手機國碼.input.state.value} interfaceOptions={customSelectContainerOptions} interface="action-sheet" placeholder="+國際碼" onIonChange={(ev) => {
                            keyedFields.手機國碼.input.state.reset_WithEndCallbacks(ev.detail.value);
                        }}
                                   multiple={false} className={styles_Pg_C_1.select}>
                            {areaCodeList.map((v) => {
                                return <IonSelectOption key={v.countryName} value={v.phoneCode}>{v.countryName} {v.phoneCode}</IonSelectOption>
                            })}
                        </IonSelect>
                    </>} field={keyedFields.手機號碼} errors={errors} noLabel={false}/>
                </IonCol>
            </IonRow>
            {phoneVerifyStage >= 1 &&
                <IonRow className="ion-justify-content-center ion-text-center ion-margin-top ">
                    <IonCol>
                        {phoneVerifyStage === 1 &&
                            <>
                                <IonButton fill={"solid"} onClick={() => _push_Pg_C_4__SendPhoneVerify()} disabled={phoneVerifyStage !== 1 ? true : false}>
                                    再次驗證手機
                                </IonButton>
                            </>
                        }
                        {phoneVerifyStage === 2 &&
                            <>
                                簡訊中，請稍後...
                            </>
                        }
                        {phoneVerifyStage === 3 &&
                            <>
                                <CustomField alternateLabel={<>
                                    <IonLabel>
                                        請檢查簡訊，並填入已寄送的代碼
                                    </IonLabel>
                                </>} alternateRightZone={<>
                                    <IonButton fill={"solid"} onClick={() => _push_Pg_C_4__PhoneVerify()} className={styles_Common.sideRight}>
                                        驗證
                                    </IonButton>
                                </>
                                } field={keyedFields.vcodePhone} errors={errors} className={styles_Pg_C_1.highlight} inputClassName={styles_Pg_C_1.hightlightColor}/>
                            </>
                        }
                        {phoneVerifyStage === 4 &&
                            <>
                                驗證完成
                            </>
                        }
                    </IonCol>
                </IonRow>
            }
            <IonRow>
                <IonCol>
                    <CustomField field={keyedFields.登入密碼} errors={errors}/>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol>
                    <CustomField field={keyedFields.個人介紹} errors={errors} textType="textarea"/>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol className={styles_Pg_0_3.topBottomSpacing}>
                    <div className={`${styles_Pg_0_3.line} ${styles_Pg_0_3.topBottomSpacing}`}></div>
                    寄送地址:
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol>

                    <CustomField field={keyedFields.寄送地址_收件人} errors={errors}/>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol>
                    <CustomField field={keyedFields.寄送地址_連絡電話} errors={errors}/>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol>
                    <CustomField field={keyedFields.寄送地址_收件地址} errors={errors} textType="textarea"/>
                </IonCol>
            </IonRow>


            <IonRow className="ion-margin-top ion-padding-top">
                <IonCol size="12">
                    <IonButton className="custom-button" expand="block" onClick={() => _push_pg_0_3()}>更新</IonButton>
                </IonCol>
            </IonRow>
        </IonGrid>
    </>

}

const Pg_0_3 = (props) => {
    const pageRef = useRef();
    const pageName = "Pg_0_3";
    const pageId = "Pg_0_3";
    const {sideMenuOptions} = props;
    const setSideMenu: any = useSideMenuUpdate();
    const sideMenu: any = useSideMenuOptions();

    const router = useIonRouter();


    //#region Data Loading
    const params = useParams();

    useEffect(() => {
        (async () => {
            let errorObj = await fetch_pg_0_3({});
            handleFetchCommonErrors(router, errorObj);
        })();
    }, []);

    let reload = async (event: CustomEvent<RefresherEventDetail>) => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        let errorObj = await fetch_pg_0_3({});
        handleFetchCommonErrors(router, errorObj);
        event?.detail?.complete();
    }

    const pgData = useStoreState(Pg_0_3_Store, getPageData);

    const hasLoaded = pgData?.Root ?? false;
    const Item_會員 = hasLoaded ? pgData.Root.Item_會員 : undefined;
    //#endregion

    return (
        <IonPage id={pageId}>
            <CustomPage name={pageName} sideMenu={true} sideMenuPosition="start" backButton={false}>
                <IonRefresher slot="fixed" onIonRefresh={reload}>
                    <IonRefresherContent
                        pullingIcon={chevronDownCircleOutline}
                        pullingText="Pull to refresh"
                        refreshingSpinner="circles"
                        refreshingText="Refreshing...">
                    </IonRefresherContent>
                </IonRefresher>

                {hasLoaded &&
                    <RenderForm router={router} Item_會員={Item_會員} reload={reload}/>
                }

            </CustomPage>
        </IonPage>
    );


};

export default Pg_0_3;
